import Vue from 'vue';
import {i18n} from '@/fit-components/common/lang';
import store from './store';
import {getDefaultConfig, ToastType} from "@/fit-components/toast/business";
interface ToastOptions {
    show?: boolean;
    type?: ToastType;
    title?: string;
    size?: number;
}

export function showToast(options: ToastOptions= {show: true}) {
    const finalConfig = Object.assign( getDefaultConfig(), options, {show: true});
    Object.keys(finalConfig).forEach((key) =>  {
        Vue.set(store.toast, key, finalConfig[key]);
    });
    //2s后隐藏
    setTimeout(()=>{
        hideToast();
    }, 2000);
}

export function hideToast() {
    store.toast.show = false;
}
